<pre class="language-xml">
    <code class="lang-xml" [textContent]="xmlData"></code>
  </pre>
